// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WorkflowProcess
 */
export interface WorkflowProcess {
  /**
   *
   */
  id: string;
  /**
   *
   */
  title: string;
}

/**
 * Check if a given object implements the WorkflowProcess interface.
 */
export function instanceOfWorkflowProcess(value: object): value is WorkflowProcess {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  return true;
}

export function WorkflowProcessFromJSON(json: any): WorkflowProcess {
  return WorkflowProcessFromJSONTyped(json, false);
}

export function WorkflowProcessFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WorkflowProcess {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    title: json["title"],
  };
}

export function WorkflowProcessToJSON(json: any): WorkflowProcess {
  return WorkflowProcessToJSONTyped(json, false);
}

export function WorkflowProcessToJSONTyped(
  value?: WorkflowProcess | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    title: value["title"],
  };
}
